import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const EMemberRequestToPartnerStatus = [
  { label: 'รอตอบกลับ', value: 'request' },
  { label: 'ตอบกลับแล้ว', value: 'response' },
  { label: 'เปลี่ยนเป็น นธก.แล้ว', value: 'completed' },
  { label: 'ยกเลิกคำขอ', value: 'reject' },
];

export const EMemberRequestToPartnerStatus2 = [
  { label: 'รอตอบกลับ', value: 'request' },
  { label: 'ตอบกลับแล้ว', value: 'response' },
  { label: 'ยกเลิกคำขอ', value: 'reject' },
  { label: 'เปลี่ยนเป็น นธก.แล้ว', value: 'completed' },
];

export const EMemberStatus = [
  { label: 'ปกติ', value: 'Active' },
  { label: 'รอชำระค่าสมัคร', value: 'Pending' },
  { label: 'รอสมุดบัญชี', value: 'Waiting' },
  { label: 'ยกเลิก', value: 'Cancel' },
  { label: 'ช่วงต่ออายุสาย 90 วัน', value: 'Expired' },
  { label: 'ผิดจนนยาบรรณ', value: 'Legal' },
  { label: 'ลาออก', value: 'Resigned' },
  { label: 'สิ้นสุดสมาชิกภาพ', value: 'Terminated' },
  { label: 'หมดอายุ', value: 'Vacated' },
  { label: 'โมฆะ', value: 'Void' },
];

export const memberRequestToPartnerFormDefaultValues = {
  StaffRemark: '',
  Status: '',
};

export const memberRequestToPartnerFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      StaffRemark: yup.string().defined(),
      Status: yup.string().required('กรุณากรอกข้อมูล'),
    })
  );
};
